import { render } from "./PostForm.vue?vue&type=template&id=316fcdac&scoped=true"
import script from "./PostForm.vue?vue&type=script&lang=js"
export * from "./PostForm.vue?vue&type=script&lang=js"

import "./PostForm.vue?vue&type=style&index=0&id=316fcdac&scoped=true&lang=css"

import exportComponent from "D:\\secret\\py\\main_bot\\bank-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-316fcdac"]])

export default __exports__